import React from "react";
import { CheckboxGroupItem } from "@/components/ui/checkbox-group";
import { Draggable } from "@hello-pangea/dnd";
import { createPortal } from "react-dom";
import { cn } from "@/utils/utils";
import Text from "@/components/ui/text";
import { ColumnData } from "@/entities/dataTables/types";

interface Props {
  column: ColumnData;
  index: number;
  onColumnChange: (view: ColumnData, checked: boolean) => void;
  isDragDisabled?: boolean;
  isCheckboxDisabled?: boolean;
}

const DraggableColumnItem: React.FC<Props> = ({
  column,
  index,
  onColumnChange,
  isDragDisabled = false,
  isCheckboxDisabled = false
}) => {
  const content = (provided: any, snapshot: any, isClone: boolean = false) => (
    <div
      ref={isClone ? null : provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      className={cn(
        "flex items-center group relative p-2 pl-[2px] h-9 rounded-md !cursor-pointer",
        snapshot.isDragging && "bg-accent",
        !snapshot.isDragging && "hover:bg-surface-hover-soft"
      )}
      style={provided.draggableProps.style}
    >
      <div className="flex items-center min-w-0 flex-1 gap-2">
        <CheckboxGroupItem
          id={column.id}
          label=""
          checked={column.isVisible}
          onCheckedChange={(checked: boolean) =>
            onColumnChange(column, checked)
          }
          disabled={isCheckboxDisabled}
          className="pointer-events-auto"
        />
        <div className="flex-1 min-w-0">
          <Text variant="body">{column.label}</Text>
        </div>
      </div>
    </div>
  );

  return (
    <Draggable
      draggableId={column.id}
      index={index}
      isDragDisabled={isDragDisabled}
    >
      {(provided, snapshot) => (
        <>
          {content(provided, snapshot)}
          {snapshot.isDragging &&
            createPortal(content(provided, snapshot, true), document.body)}
        </>
      )}
    </Draggable>
  );
};

export default DraggableColumnItem;
